import extendNode from '../extendNode.mjs'
import useArCatNode from '../_AR_CAT/useArCatNode.jsx'
import meta from './metaUpRule.mjs'

export default () => {
    const ArCatNode = useArCatNode()

    return extendNode(ArCatNode, {
        ...meta,

        getText(map, node) {
            return `${this.name.slice(0, 4)}\n${this.name.slice(4)}`
        },
    })
}
